import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'split',
    standalone: false,
})
export class SplitPipe implements PipeTransform {
    transform(value: string, index = 0, splitOn = ',') {
        if (!value) {
            return '';
        }

        const splitted = value?.split(splitOn);

        if (splitted && typeof splitted[index] !== 'undefined') {
            return splitted[index];
        }

        return '';
    }
}
